<!--
 * Currency Selector Modal - Shared bottom sheet popup for currency selection
 * 货币选择器弹窗 - 共享的底部弹出式货币选择弹窗
 -->
<style scoped lang="sass">
.modal_overlay
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background: rgba(0, 0, 0, 0.6)
  display: flex
  align-items: flex-end
  justify-content: center
  z-index: 9999

  .modal_content
    background: #fff
    border-radius: 16px 16px 0 0
    padding: 20px 20px 80px
    width: 100%
    max-height: 70vh
    overflow-y: auto
    box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.2)

    .modal_title
      font-size: 18px
      font-weight: 700
      color: #333
      text-align: center
      margin-bottom: 16px
      padding-bottom: 12px
      border-bottom: 1px solid #eee

    .currency_list
      display: flex
      flex-direction: column
      gap: 8px

      .currency_item
        display: flex
        align-items: center
        padding: 14px 16px
        background: #f8f8f8
        border-radius: 12px
        cursor: pointer
        transition: all 0.2s ease

        &:active
          transform: scale(0.98)

        &.active
          background: var(--menu-primary-background-colour)

          .name,
          .symbol
            color: #fff

        .flag_icon
          width: 24px
          height: 24px
          border-radius: 50%
          margin-right: 12px
          flex-shrink: 0
          object-fit: cover

        .name
          flex: 1
          font-size: 16px
          font-weight: 600
          color: #333

        .symbol
          font-size: 14px
          color: #666

    .close_btn
      margin-top: 16px
      padding: 14px
      background: #f0f0f0
      border-radius: 12px
      text-align: center
      font-size: 16px
      font-weight: 600
      color: #666
      cursor: pointer
      transition: all 0.2s ease

      &:active
        transform: scale(0.98)
        background: #e0e0e0

.slide-up-enter-active,
.slide-up-leave-active
  transition: all 0.3s ease

.slide-up-enter,
.slide-up-leave-to
  opacity: 0
  transform: translateY(100%)
</style>

<style lang="sass">
.curr_modal_component .fi
  width: 1em
  height: 1em
  background-size: cover
  border-radius: 50%
</style>

<template lang="pug">
transition(name="slide-up")
  .modal_overlay.curr_modal_component(v-if="show" @click.self="$emit('close')")
    .modal_content
      .modal_title {{ t('select_currency', 'Select Currency') }}
      .currency_list
        .currency_item(
          v-for="currency in currencies"
          :key="currency.code"
          :class="{ active: currency.code === currentCurrency }"
          @click="$emit('select', currency.code)"
        )
          span.flag_icon.fi.fis(:class="'fi-' + getCountryCode(currency)")
          span.name {{ currency.name }}
          span.symbol ({{ currency.symbol }})
      .close_btn(@click="$emit('close')") {{ t('close', 'Close') }}
</template>

<script>
import { t } from '@/utils/language'

const EMOJI_TO_CODE = {
  '\u{1F1E6}\u{1F1FA}': 'au',
  '\u{1F1FA}\u{1F1F8}': 'us',
  '\u{1F1EA}\u{1F1FA}': 'eu',
  '\u{1F1EC}\u{1F1E7}': 'gb',
  '\u{1F1E8}\u{1F1F3}': 'cn',
  '\u{1F1EF}\u{1F1F5}': 'jp',
  '\u{1F1F3}\u{1F1FF}': 'nz',
  '\u{1F1F8}\u{1F1EC}': 'sg',
  '\u{1F1ED}\u{1F1F0}': 'hk',
  '\u{1F1E8}\u{1F1E6}': 'ca',
  '\u{1F1EB}\u{1F1F7}': 'fr',
}

export default {
  name: 'CurrencySelectorModal',
  props: {
    show: { type: Boolean, default: false },
    currencies: { type: Array, default: () => [] },
    currentCurrency: { type: String, default: 'AUD' },
  },
  methods: {
    t,
    getCountryCode(item) {
      if (item.countryCode) return item.countryCode
      if (item.flag && EMOJI_TO_CODE[item.flag]) return EMOJI_TO_CODE[item.flag]
      return 'au'
    },
  },
}
</script>
